import { MInput } from "components/forms";

import {
  adminService,
  dateHelper,
  learningService,
  networkErrorHelper,
} from "libs";

import { Button, Container, Col, Row } from "design-react-kit";

import React, { Component } from "react";
import { MTable } from "components/table";
import { MnemoCallout, MnemoLoading, MSection, Title } from "components/misc";
import { CourseLessonSectionTable } from "components/course";

export default class LessonStudentSchedule extends Component {
  state = {
    loading: false,
    loadingError: false,
    rndKey: 0,
    rCode: "",
    user: null,
    course: null,
    userCourse: null,
    lessons: [],
    sections: [],
    analytics: [],
    lessonCreditRecognition: [],
    hasSearched: false,
    viewMode: "section", //schedule or section
    error: null,
  };

  loadUserCourse = () => {
    this.setState({ loading: true });
    learningService
      .courseDashboard(this.state.rCode)
      .then(({ data }) => {
        const { user, course, userCourse } = data.payload;

        this.setState({
          user,
          course,
          userCourse,
        });

        this.loadRemote(course.id, userCourse.registrationCode);
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }
      });
  };

  loadRemote = (courseId, rCode) => {
    adminService
      .loadLessonStudentSchedule(courseId, rCode)
      .then(({ data }) => {
        const { lessons, sections, analytics, lessonCreditRecognition } =
          data.payload;
        this.setState({
          loading: false,
          lessons,
          sections,
          analytics,
          lessonCreditRecognition,
          hasSearched: true,
        });
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }

        this.setState({
          loading: false,
          loadingError: true,
        });
      });
  };

  tableConfig = {
    columns: [
      {
        id: "id", // identifier of columns
        Header: "Column 0",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "id", // accessor is the "key" in the data
      },
      {
        id: "title",
        Header: "Titolo",
        accessor: "subject", // accessor is the "key" in the data
      },
      {
        id: "date",
        Header: "Data",
        accessor: (row) => {
          return row.date ? dateHelper.toITDateUTC(row.date) : "";
        },
      },
      {
        id: "hourStart",
        Header: "Ora inizio",
        accessor: (row) => {
          return row.hourStart
            ? row.hourStart.substring(0, row.hourStart.length - 3)
            : "";
        },
      },
      {
        id: "teacher",
        Header: "Docente",
        accessor: "teacher",
      },
      {
        id: "ssd",
        Header: "Materia",
        accessor: "ssd",
      },
      {
        id: "competitionClass",
        Header: "Classe di concorso",
        accessor: "competitionClass",
      },
      {
        id: "section",
        Header: "Modulo",
        accessor: "section",
      },
    ],
    actions: [],
  };

  tableTrainingConfig = {
    columns: [
      {
        id: "id", // identifier of columns
        Header: "Column 0",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "id", // accessor is the "key" in the data
      },
      {
        id: "mode",
        Header: "Modalità",
        accessor: "mode", // accessor is the "key" in the data
      },
      {
        id: "title",
        Header: "Titolo",
        accessor: "subject", // accessor is the "key" in the data
      },
      {
        id: "date",
        Header: "Data",
        accessor: (row) => {
          return row.date ? dateHelper.toITDateUTC(row.date) : "";
        },
      },
      {
        id: "hourStart",
        Header: "Ora inizio",
        accessor: (row) => {
          return row.hourStart
            ? row.hourStart.substring(0, row.hourStart.length - 3)
            : "";
        },
      },
      {
        id: "teacher",
        Header: "Docente",
        accessor: "teacher",
      },
      {
        id: "ssd",
        Header: "Materia",
        accessor: "ssd",
      },
      {
        id: "competitionClass",
        Header: "Classe di concorso",
        accessor: "competitionClass",
      },
      {
        id: "section",
        Header: "Modulo",
        accessor: "section",
      },
    ],
    actions: [],
  };

  getLessonsByType(lessons) {
    return {
      onlineLessons: lessons.filter((l) => l.lessonType === "live"),
      onSiteLessons: lessons.filter((l) => l.lessonType === "onsite"),
      trainingLessons: lessons.filter((l) => l.lessonType === "training"),
    };
  }

  onChange = (id, value) => {
    this.setState({ rCode: value });
  };

  render() {
    const {
      loading,
      rndKey,
      rCode,
      user,
      course,
      userCourse,
      lessons,
      sections,
      analytics,
      lessonCreditRecognition,
      hasSearched,
      viewMode,
    } = this.state;

    const { onlineLessons, onSiteLessons, trainingLessons } =
      this.getLessonsByType(lessons);

    return (
      <div className="container">
        <Title>Calendario Lezioni per Studente</Title>

        <Container className="mt-3">
          <Row>
            <Col md="4">
              <MInput
                id="registrationCode"
                label="Codice Registrazione"
                value={rCode}
                onChange={this.onChange}
              />
            </Col>
            <Col md="2">
              <Button
                color="primary bg-dark"
                className="ml-2"
                onClick={this.loadUserCourse}
              >
                Cerca
              </Button>
            </Col>
          </Row>
        </Container>

        {loading ? (
          <MnemoLoading></MnemoLoading>
        ) : (
          hasSearched && (
            <>
              <MnemoCallout>
                <Row>
                  <Col md={8}>
                    <b>Nome</b>: {user.name}
                    <br />
                    <b>Cognome</b>: {user.surname}
                    <br />
                    <b>Email</b>: {user.email}
                    <br />
                    <b>Titolo corso</b>: {course.title}
                    <br />
                    <b>Codice corso</b>: {course.code}
                  </Col>
                </Row>
              </MnemoCallout>

              <Container>
                <Row className="my-4 text-center">
                  <Col>
                    <Button
                      color={
                        viewMode === "section" ? "secondary" : "primary bg-dark"
                      }
                      onClick={() => this.setState({ viewMode: "section" })}
                    >
                      Calendario attività formative
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      color={
                        viewMode === "schedule"
                          ? "secondary"
                          : "primary bg-dark"
                      }
                      onClick={() => this.setState({ viewMode: "schedule" })}
                    >
                      Calendario completo lezioni
                    </Button>
                  </Col>
                </Row>
              </Container>

              {viewMode === "section" ? (
                <CourseLessonSectionTable
                  rCode={rCode}
                  userCourse={userCourse}
                  lessons={lessons}
                  sections={sections}
                  analytics={analytics}
                  lessonCreditRecognition={lessonCreditRecognition}
                  hideDetailsButton={true}
                />
              ) : (
                <>
                  <MSection className="m-2">
                    <h3 className="mb-0">Lezioni online</h3>
                    {onlineLessons?.length > 0 ? (
                      <MTable
                        key={rndKey}
                        tableData={onlineLessons}
                        tableConfig={this.tableConfig}
                      />
                    ) : (
                      <p>Nessuna lezione online.</p>
                    )}
                  </MSection>

                  <MSection className="m-2">
                    <h3 className="mb-0">Lezioni in presenza</h3>
                    {onSiteLessons.length > 0 ? (
                      <MTable
                        key={rndKey}
                        tableData={onSiteLessons}
                        tableConfig={this.tableConfig}
                      />
                    ) : (
                      <p>Nessuna lezione in presenza.</p>
                    )}
                  </MSection>

                  <MSection className="m-2">
                    <h3 className="mb-0">Tirocinio indiretto</h3>
                    {trainingLessons.length > 0 ? (
                      <MTable
                        key={this.state.rndKey}
                        tableData={trainingLessons}
                        tableConfig={this.tableTrainingConfig}
                      />
                    ) : (
                      <p>Nessuna attività di tirocinio indiretto.</p>
                    )}
                  </MSection>
                </>
              )}
            </>
          )
        )}
      </div>
    );
  }
}
